module.exports = __webpack_public_path__ + "static/img/qq.51c4c215.png";